module.exports = __webpack_public_path__ + "assets/media/evening.1abd3261.mp3";